import { render } from "./DynamicField.vue?vue&type=template&id=80c9a5ec&scoped=true"
import script from "./DynamicField.vue?vue&type=script&lang=js"
export * from "./DynamicField.vue?vue&type=script&lang=js"

import "./DynamicField.vue?vue&type=style&index=0&id=80c9a5ec&lang=scss&scoped=true"

import exportComponent from "/Users/shuaqq/Desktop/jysports/vue3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80c9a5ec"]])

export default __exports__